export default __webpack_public_path__ + "8cb1d2b85494737a278b2cc575d8f4a2.png";